import { DependenciesInjection } from "app/di/DependencyInjection";
import { GeneralImpl } from "../data/GeneralsImpl";
import { IGeneralRepository } from "../domain/repositories/IGeneralRepository";
import { GeneralsUseCase } from "../domain/useCases/GeneralsUseCase";
import { GeneralsToken } from "./GeneralsToken";

export class GeneralsInjection {
  static initInjections() {
    DependenciesInjection.register<IGeneralRepository>(
      GeneralsToken.IGeneralRepository,
      GeneralImpl,
      "otherRepo",
    );
    DependenciesInjection.register<GeneralsUseCase>(
      GeneralsToken.GeneralsUseCase,
      GeneralsUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IGeneralRepository>(
      GeneralsToken.IGeneralRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<GeneralsUseCase>(
      GeneralsToken.GeneralsUseCase,
    );
  }
}
